export { default } from "./AdvertiseLink";
